import { Communicator } from "@dataverse/communicator";
import { Methods } from "./types/event";
export class Wallet {
    constructor(communicator) {
        this.communicator = communicator;
    }
    getCurrentPkh(params) {
        return this.communicator.sendRequest({
            method: Methods.getCurrentPkh,
            params,
        });
    }
}
export class RuntimeConnector {
    constructor(postMessageTo) {
        this.communicator = new Communicator({
            source: window,
            target: window.top,
            postMessageTo,
        });
        this.wallet = new Wallet(this.communicator);
    }
    setPostMessageTo(postMessageTo) {
        this.communicator.setPostMessageTo(postMessageTo);
    }
    connectWallet(wallet) {
        return this.communicator.sendRequest({
            method: Methods.connectWallet,
            params: wallet,
        });
    }
    switchNetwork(chainId) {
        return this.communicator.sendRequest({
            method: Methods.switchNetwork,
            params: chainId,
        });
    }
    sign(params) {
        return this.communicator.sendRequest({
            method: Methods.sign,
            params,
        });
    }
    contractCall(params) {
        return this.communicator.sendRequest({
            method: Methods.contractCall,
            params,
        });
    }
    ethereumRequest(params) {
        return this.communicator.sendRequest({
            method: Methods.ethereumRequest,
            params,
        });
    }
    getPKP() {
        return this.communicator.sendRequest({
            method: Methods.getPKP,
        });
    }
    executeLitAction(params) {
        return this.communicator.sendRequest({
            method: Methods.executeLitAction,
            params,
        });
    }
    getDAppTable(params) {
        return this.communicator.sendRequest({
            method: Methods.getDAppTable,
            params,
        });
    }
    getDAppInfo(params) {
        return this.communicator.sendRequest({
            method: Methods.getDAppInfo,
            params,
        });
    }
    getValidAppCaps(params) {
        return this.communicator.sendRequest({
            method: Methods.getValidAppCaps,
            params,
        });
    }
    getModelBaseInfo(modelId) {
        return this.communicator.sendRequest({
            method: Methods.getModelBaseInfo,
            params: modelId,
        });
    }
    createCapability(params) {
        return this.communicator.sendRequest({
            method: Methods.createCapability,
            params,
        });
    }
    checkCapability(params) {
        return this.communicator.sendRequest({
            method: Methods.checkCapability,
            params,
        });
    }
    createStream(params) {
        return this.communicator.sendRequest({
            method: Methods.createStream,
            params,
        });
    }
    updateStream(params) {
        return this.communicator.sendRequest({
            method: Methods.updateStream,
            params,
        });
    }
    loadStream(streamId) {
        return this.communicator.sendRequest({
            method: Methods.loadStream,
            params: streamId,
        });
    }
    loadStreamsBy(params) {
        return this.communicator.sendRequest({
            method: Methods.loadStreamsBy,
            params,
        });
    }
    readFolders() {
        return this.communicator.sendRequest({
            method: Methods.readFolders,
        });
    }
    createFolder(params) {
        return this.communicator.sendRequest({
            method: Methods.createFolder,
            params,
        });
    }
    updateFolderBaseInfo(params) {
        return this.communicator.sendRequest({
            method: Methods.updateFolderBaseInfo,
            params,
        });
    }
    changeFolderType(params) {
        return this.communicator.sendRequest({
            method: Methods.changeFolderType,
            params,
        });
    }
    deleteFolder(folderId) {
        return this.communicator.sendRequest({
            method: Methods.deleteFolder,
            params: folderId,
        });
    }
    monetizeFolder(params) {
        return this.communicator.sendRequest({
            method: Methods.monetizeFolder,
            params,
        });
    }
    uploadFile(params) {
        return this.communicator.sendRequest({
            method: Methods.uploadFile,
            params,
        });
    }
    updateFileBaseInfo(params) {
        return this.communicator.sendRequest({
            method: Methods.updateFileBaseInfo,
            params,
        });
    }
    moveFiles(params) {
        return this.communicator.sendRequest({
            method: Methods.moveFiles,
            params,
        });
    }
    removeFiles(params) {
        return this.communicator.sendRequest({
            method: Methods.removeFiles,
            params,
        });
    }
    monetizeFile(params) {
        return this.communicator.sendRequest({
            method: Methods.monetizeFile,
            params,
        });
    }
    createProfile(handle) {
        return this.communicator.sendRequest({
            method: Methods.createProfile,
            params: handle,
        });
    }
    getProfiles(address) {
        return this.communicator.sendRequest({
            method: Methods.getProfiles,
            params: address,
        });
    }
    unlock(params) {
        return this.communicator.sendRequest({
            method: Methods.unlock,
            params,
        });
    }
    isCollected(params) {
        return this.communicator.sendRequest({
            method: Methods.isCollected,
            params,
        });
    }
    getDatatokenBaseInfo(datatokenId) {
        return this.communicator.sendRequest({
            method: Methods.getDatatokenBaseInfo,
            params: datatokenId,
        });
    }
}
